import React from 'react';
import PropTypes from 'prop-types';

import InfoBlock from 'js/components/InfoColumnBlocks/InfoBlock';
import RelatedQuestions from 'js/pages/QuestionPage/RelatedQuestions';
import TreatmentFilesSlots from 'js/pages/QuestionPage/TreatmentFilesSlots';

import styles from './styles.module.css';

const Sidebar = ({
  generateUri,
  i18n,
  question,
  treatmentDescription,
  treatmentFiles,
}) => {
  const primaryTreatment = question.treatmentCategories[0];
  const { infoPageEnabled, name, normalisedName, image } = primaryTreatment;
  const treatmentImage = Object.values(image.uris || {})[0];
  const treatmentUri = generateUri('treatment', {
    normalisedName,
  });
  const showAllQuestionsUri = `${treatmentUri}#questions`;

  return (
    <div className={styles.sidebar}>
      {infoPageEnabled ? (
        <InfoBlock
          imageUri={treatmentImage}
          title={name}
          description={treatmentDescription}
          uri={treatmentUri}
          ctaText={i18n('page.question.treatment-guide-cta')}
        />
      ) : null}
      <TreatmentFilesSlots
        treatmentFiles={treatmentFiles}
        headerText={i18n('page.question.treatment-files-header')}
      />
      {infoPageEnabled ? (
        <RelatedQuestions
          questions={question.relatedQuestions}
          ctaUri={showAllQuestionsUri}
          i18n={i18n}
        />
      ) : null}
    </div>
  );
};

Sidebar.propTypes = {
  i18n: PropTypes.func,
  generateUri: PropTypes.func,
  question: PropTypes.object,
  treatmentDescription: PropTypes.string,
  treatmentFiles: PropTypes.array,
};

export default Sidebar;
